<header class="app-header navbar" *ngIf="showHeaderFooter">
  <button
    class="navbar-toggler d-lg-none"
    type="button"
    appMobileSidebarToggler
  >
    &#9776;
  </button>
  <a class="navbar-brand" routerLink="/user">
    <img src="assets/img/logo.png" />
  </a>
  <button class="navbar-toggler d-md-down-none" type="button" appSidebarToggler>
    &#9776;
  </button>
  <ul class="nav navbar-nav ml-auto">
    <li class="nav-item dropdown" ngbDropdown>
      <a class="nav-link dropdown-toggle" ngbDropdownToggle>
        <img
          src="assets/img/avatars/user.png"
          *ngIf="userData.image == ''"
          class="img-avatar"
        />
        <img
          *ngIf="userData.image != ''"
          [src]="userData.image"
          class="img-avatar"
        />
        <span class="d-md-down-none">{{ userData.profileName }}</span>
      </a>
      <div
        class="dropdown-menu dropdown-menu-left"
        ngbDropdownMenu
        aria-labelledby="dropdownBasic1"
      >
        <a class="dropdown-item" routerLink="/profile-settings"
          ><i class="fa fa-user"></i> Profile</a
        >
        <a class="dropdown-item" (click)="logout()"
          ><i class="fa fa-lock"></i> Logout</a
        >
      </div>
    </li>
  </ul>
</header>
<div
  class="app-body"
  [ngClass]="{
    'full-width': !showHeaderFooter,
    'no-margin': !showHeaderFooter
  }"
>
  <div class="sidebar" *ngIf="showHeaderFooter">
    <nav class="sidebar-nav">
      <ul class="nav">
        <li
          *ngIf="wepMenuList.length > 0"
          class="nav-item nav-dropdown open"
          routerLinkActive="open"
          appNavDropdown
        >
          <a class="nav-link nav-dropdown-toggle bg-white" appNavDropdownToggle>
            <strong>WEP</strong>
          </a>
          <ul class="nav-dropdown-items bg-child-1">
            <ng-container *ngFor="let item of wepMenuList; let i = index">
              <li
                class="nav-item"
                [ngClass]="{
                  'nav-dropdown': item.children && item.children.length > 0,
                  open: openMenuIndex === i
                }"
              >
                <a
                  *ngIf="!item.children || item.children.length === 0"
                  class="nav-link"
                  [routerLink]="['/', item.route]"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <i class="{{ item.icon }}"></i> {{ item.name }}
                </a>

                <a
                  *ngIf="item.children && item.children.length > 0"
                  class="nav-link nav-dropdown-toggle"
                  (click)="toggleDropdown(i)"
                  role="button"
                  [attr.aria-expanded]="openMenuIndex === i"
                >
                  <i class="{{ item.icon }}"></i> {{ item.name }}
                </a>

                <ul
                  class="nav-dropdown-items"
                  *ngIf="item.children && item.children.length > 0"
                >
                  <li class="nav-item" *ngFor="let sub of item.children">
                    <a
                      class="nav-link pl-3"
                      [routerLink]="['/', sub.route]"
                      [ngClass]="{ active: isActive(sub) }"
                    >
                      {{ sub.subMenu }}
                    </a>
                  </li>
                </ul>
              </li>
            </ng-container>
          </ul>
        </li>

        <!-- CII Menu -->
        <li
          *ngIf="ciiMenuList.length > 0"
          class="nav-item nav-dropdown"
          routerLinkActive="open"
          appNavDropdown
        >
          <a class="nav-link nav-dropdown-toggle bg-white" appNavDropdownToggle>
            <strong>CII</strong>
          </a>
          <ul class="nav-dropdown-items bg-child-1">
            <ng-container *ngFor="let item of ciiMenuList; let i = index">
              <li
                class="nav-item"
                [ngClass]="{
                  'nav-dropdown': item.children && item.children.length > 0,
                  open: openCiiMenuIndex === i
                }"
              >
                <a
                  *ngIf="!item.children || item.children.length === 0"
                  class="nav-link"
                  [routerLink]="['/', item.route]"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <i class="{{ item.icon }}"></i> {{ item.name }}
                </a>

                <a
                  *ngIf="item.children && item.children.length > 0"
                  class="nav-link nav-dropdown-toggle"
                  (click)="toggleCiiDropdown(i)"
                  role="button"
                  [attr.aria-expanded]="openCiiMenuIndex === i"
                >
                  <i class="{{ item.icon }}"></i> {{ item.name }}
                </a>

                <ul
                  class="nav-dropdown-items"
                  *ngIf="item.children && item.children.length > 0"
                >
                  <li class="nav-item" *ngFor="let sub of item.children">
                    <a
                      class="nav-link pl-3"
                      [routerLink]="['/', sub.route]"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="openCiiMenuIndex = i"
                    >
                      {{ sub.subMenu }}
                    </a>
                  </li>
                </ul>
              </li>
            </ng-container>
          </ul>
        </li>
      </ul>
    </nav>
  </div>

  <main class="main">
    <div class="container-fluid mt-3">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>

<footer class="app-footer">
  Copyright &copy; WEP. All rights reserved 2022.
</footer>
